<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.admin.account.title.add")}}</h1>
      </v-col>
    </v-row>

    <!-- エラー -->
    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.admin.account.error." />
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="12" class="text-right">
        <span class="red--text">※</span>は必須項目です
      </v-col>
    </v-row>

    <!-- ID -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.mailAddress")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.mailAddress"
          v-bind:placeholder="$t('message.admin.account.ph.mailAddress')"
          id="mailAddress"
          hide-details
          solo
          maxlength="100"
          required
          validate-on-blur
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 氏名 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.name")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.name"
          v-bind:placeholder="$t('message.admin.account.ph.name')"
          id="name"
          hide-details
          solo
          maxlength="50"
          required
          validate-on-blur
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 所属 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.group")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-row v-for="(item, index) in getGroupList"
          :key="item.groupLargeId"
        >

          <v-col class="pa-1 pl-3">
            <v-radio-group v-model="form.groupLargeId" class="mt-0">
                <v-radio
                :label="item.groupLargeName.ja"
                :value="item.groupLargeId"
                :id="`groupLargeId-${item.groupLargeId}`"
                hide-details
                dense
                @change="changeGroupLarge(item.groupLargeId, item.companyInsNoFlg)"
                />
              </v-radio-group>
            </v-col>
          <v-col class="py-1 pr-3">
              <v-select
              v-model="form.groupSmallId"
              :items="view.groupList[index].groupSmallList"
              label="選択してください"
              :item-text="getGroupSmallName"
              item-value="groupSmallId"
              :id="`groupSmallId-${item.groupLargeId}`"
              hide-details
              solo
              dense
              :disabled="form.groupLargeId !== item.groupLargeId"
              @change="(groupSmallId) => changeGroupSmall(groupSmallId, item.companyInsNoFlg)"
              ></v-select>
            </v-col>

          </v-row>
      </v-col>
    </v-row>

    <!-- 会社 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{view.companyLabel.ja}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1'">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-autocomplete
            v-model="form.companyId"
            :items="view.companyList"
            :label="$t('message.admin.account.ph.companyId')"
            item-text="companyName"
            item-value="companyId"
            :disabled="view.companyList.length === 0 || view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg === '1'"
            id="companyId"
            hide-details
            solo
            dense
            @change="changeCompany"
          ></v-autocomplete>
          <v-text-field
            v-if="form.companyId === constantValue.otherCompanyId"
            v-model="form.companyName"
            v-bind:placeholder="$t('message.admin.account.ph.companyName').replace('##COMPANY_LABEL##', view.companyLabel.ja)"
            id="companyName"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-if="form.companyId === constantValue.otherCompanyId"
            v-model="form.companyNameKana"
            v-bind:placeholder="$t('message.admin.account.ph.companyNameKana').replace('##COMPANY_LABEL##', view.companyLabel.ja)"
            id="companyNameKana"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
      </v-col>
    </v-row>

    <!-- 支社・支局または媒体 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{view.branchLabel.ja}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1' && view.branchList.length > 1">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-autocomplete
            v-model="form.branchId"
            :items="view.branchList"
            :label="$t('message.admin.account.ph.branch').replace('##BRANCH_LABEL##', view.branchLabel.ja)"
            item-text="branchName"
            item-value="branchId"
            :disabled="view.branchList.length === 0 || view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg === '1'"
            id="branchId"
            hide-details
            solo
            dense
            @change="changeBranch"
          ></v-autocomplete>
          <v-text-field
            v-if="form.branchId === constantValue.otherBranchId"
            v-model="form.branchName"
            v-bind:placeholder="$t('message.admin.account.ph.branchName').replace('##BRANCH_LABEL##', view.branchLabel.ja)"
            id="branchName"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-if="form.branchId === constantValue.otherBranchId"
            v-model="form.branchNameKana"
            v-bind:placeholder="$t('message.admin.account.ph.branchNameKana').replace('##BRANCH_LABEL##', view.branchLabel.ja)"
            id="branchNameKana"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
      </v-col>
    </v-row>

    <!-- 郵便番号 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.postNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.postNo"
          hide-details
          v-bind:placeholder="$t('message.admin.account.ph.postNo')"
          id="postNo"
          solo
          dense
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 都道府県 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.prefCd")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-select
            v-model="form.prefCd"
            :items="$store.getters.prefCodeList"
            :item-text="getPrefName"
            item-value="kbnCd"
            :label="$t('message.admin.account.ph.prefCd')"
            id="prefCd"
            hide-details
            dense
            solo
          ></v-select>
      </v-col>
    </v-row>

    <!-- 市区町村 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.addr1")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr1"
          v-bind:placeholder="$t('message.admin.account.ph.addr1')"
          id="addr1"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 番地 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.addr2")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr2"
          v-bind:placeholder="$t('message.admin.account.ph.addr2')"
          id="addr2"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- ビル名 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.addr3")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr3"
          v-bind:placeholder="$t('message.admin.account.ph.addr3')"
          id="addr3"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 部署 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.busho")}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1'">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.busho"
          v-bind:placeholder="$t('message.admin.account.ph.busho')"
          id="busho"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 電話番号 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.telNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.telNo"
          v-bind:placeholder="$t('message.admin.account.ph.telNo')"
          id="telNo"
          hide-details
          dense
          solo
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 備考 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>備考</mp-label>
      </v-col>
      <v-col cols="8">
        <v-textarea
          v-model="form.remarks"
          v-bind:placeholder="$t('message.admin.account.ph.remarks')"
          id="remarks"
          hide-details
          dense
          solo
          maxlength="20000"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 利用希望サービス -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.services")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox v-for="(item) in view.serviceList"
          :key="item.serviceId"
          v-model="form.services"
          :label="item.serviceName.ja"
          :value="item.serviceId"
          :id="`serviceId-${item.serviceId}`"
          :disabled="!(item.groupLargeIdList.includes(form.groupLargeId) && item.groupSmallIdList.includes(form.groupSmallId)) || !view.userServiceList.includes(item.serviceId)"
          hide-details
          dense
          class="my-2 py-0"
        >
        </v-checkbox>
      </v-col>
    </v-row>

    <!-- 管理者設定 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.adminFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox
          hide-details
          dense
          class="my-2 py-0"
          v-model="form.adminFlg"
          :label="$t('message.admin.account.ph.adminFlg')"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">{{ $t('message.admin.account.button.back') }}</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="beforeRegister">{{ $t('message.admin.account.button.add') }}</mp-button>
        <form-confirm :show="dialog.inputConfirm" :optionForm="form"
            :group="view.groupList" :company="view.companyList" :branch="view.branchList" :service="view.serviceList"
            :companyLabel="view.companyLabel" :branchLabel="view.branchLabel"
            @clickOk="goRegister" @clickCancel="dialog.inputConfirm = false"/>
        <mp-dialog regist :show="dialog.registComplete" @clickOk="goList" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpLabel from '@/components/item/MpLabel.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { AdminAccount, Common } from '@/api'
import constantValue from '@/constantValue'
import MpError from '@/components/item/MpError'
import FormConfirm from './AddConfirm.vue'
import StringUtils from '@/utils/StringUtil'

export default {
  name: 'AdminAccountAdd',
  components: {
    MpError,
    MpLabel,
    MpButton,
    MpDialog,
    FormConfirm
  },
  data: () => ({
    constantValue: constantValue,
    view: {
      companyDefaultLabel: {
        ja: ''
      },
      branchDefaultLabel: {
        ja: ''
      },
      companyLabel: {
        ja: ''
      },
      branchLabel: {
        ja: ''
      },
      groupList: [],
      companyList: [],
      branchList: [],
      serviceList: [],
      userServiceList: [],
      errors: []
    },
    form: {
      mailAddress: '',
      name: '',
      groupLargeId: '',
      companyInsNoFlg: '',
      groupSmallId: '',
      companyId: '',
      companyName: '',
      companyNameKana: '',
      branchId: '',
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: [],
      adminFlg: false
    },
    dialog: {
      inputConfirm: false,
      registComplete: false
    },
    errMessageReplaceList: []
  }),
  computed: {
    getGroupList () {
      return this.view.groupList
    }
  },
  methods: {
    initCompanyList () {
      this.view.companyList = []
      this.form.companyId = null
      this.form.companyName = null
      this.form.companyNameKana = null
    },
    initBranchList () {
      // 一覧および入力・選択情報を初期化
      this.view.branchList = []
      this.form.branchId = null
      this.form.branchName = null
      this.form.branchNameKana = null
    },
    initServiceList () {
      this.form.services = []
    },
    initCompanyAndBranchLabel () {
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
      this.view.branchLabel.ja = this.view.branchDefaultLabel.ja
    },
    changeGroupLarge (groupLargeId, companyInsNoFlg) {
      // サービス、会社および支社・支局または媒体を初期化
      this.initServiceList()
      this.initBranchList()
      this.initCompanyList()
      this.initCompanyAndBranchLabel()

      this.form.companyInsNoFlg = companyInsNoFlg
      this.form.groupSmallId = null
    },
    changeGroupSmall (groupSmallId, companyInsNoFlg) {
      // サービス、会社および支社・支局または媒体を初期化
      this.initServiceList()
      this.initBranchList()
      this.initCompanyList()
      this.setCompanyAndBranchLabel(groupSmallId)

      // 会社情報を設定
      if (companyInsNoFlg === '0') {
        this.getCompanyList(groupSmallId)
      }
    },
    setCompanyAndBranchLabel (groupSmallId) {
      const groupSmall = this.view.groupList
        .flatMap(groupLarge => groupLarge.groupSmallList)
        .find(groupSmall => groupSmall.groupSmallId === Number(groupSmallId))

      if (groupSmall === undefined) {
        this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
        this.view.branchLabel.ja = this.view.branchDefaultLabel.ja
      } else {
        this.view.companyLabel.ja = StringUtils.isEmpty(groupSmall.companyLabel.ja) ? this.view.companyDefaultLabel.ja : groupSmall.companyLabel.ja
        this.view.branchLabel.ja = StringUtils.isEmpty(groupSmall.branchLabel.ja) ? this.view.branchDefaultLabel.ja : groupSmall.branchLabel.ja
      }
    },
    getGroupSmallName (item) {
      // 小分類の選択肢の名前を多国語対応するためメソッドとして外だし->日本語のみに変更
      return item.groupSmallName.ja
    },
    getPrefName (item) {
      // 都道府県の選択肢の名前を多国語対応するためメソッドとして外だし->日本語のみに変更
      return item.kbnVal.ja
    },
    async getCompanyList (groupSmallId) {
      // 返却用のリスト準備
      this.view.companyList = [
        ...(await Common.companyList({ groupSmallId: groupSmallId })),
        { companyName: i18n.t('message.admin.account.select.other'), companyId: constantValue.otherCompanyId }]
    },
    changeCompany (companyId) {
      // 会社の一部と支社・支局または媒体を初期化
      this.form.companyName = null
      this.form.companyNameKana = null
      this.initBranchList()

      // 支社・支局または媒体の一覧をセット
      this.getBranchList(companyId)
    },
    async getBranchList (companyId) {
      // 返却用のリスト準備
      this.view.branchList = [
        ...(await Common.branchList({ companyId: companyId })),
        { branchName: i18n.t('message.admin.account.select.other'), branchId: constantValue.otherBranchId }
      ]
    },
    changeBranch () {
      // 支社・支局または媒体を初期化
      this.form.branchName = null
      this.form.branchNameKana = null
    },
    goList () {
      // 一覧に戻る
      this.$router.push({ path: '/admin/account/list' })
    },
    async beforeRegister () {
      if (this.form.mailAddress !== '') {
        // 入力内容確認ダイアログを表示
        this.dialog.inputConfirm = true
        return
      }
      await this.goRegister() // メールアドレス未入力ならAPIコールへ
    },
    async goRegister () {
      this.dialog.inputConfirm = false
      await AdminAccount.register({ ...this.form, adminFlg: this.form.adminFlg ? '1' : '0' })
        .then(() => {
          this.dialog.registComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.company.ja')
      this.view.branchLabel.ja = this.view.branchDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.branch.ja')
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    setErrMessageReplaceList () {
      this.errMessageReplaceList = [
        { param: 'companyId', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyName', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyNameKana', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'branchId', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchName', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchNameKana', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel }
      ]
    }
  },
  created: async function () {
    this.view.constantValue = constantValue
    this.view.groupList = await Common.groupList()
    this.view.serviceList = await Common.serviceList()
    this.view.userServiceList = (await Common.userServiceList()).map(service => service.serviceId)
    await this.setDefaultLabel()
    this.setErrMessageReplaceList()
  }
}
</script>

<style scoped>
.v-messages {
  min-height: 0px !important;
}
</style>
